import { makeAutoObservable } from 'mobx'
import { RootStore } from 'stores'
import { IFilter, Where } from 'types/common'
import { handleError } from 'API'
import { getMetrics, countMetrics, createMetric, updateMetric, deleteMetric, ICreateMetricDto } from 'API/metric'
import { IMetric } from 'interfaces/metric'

export default class MetricStore {
  rootStore: RootStore

  metrics: IMetric[] = []
  metricsLength: number = 0
  isFetching: boolean = false
  selectedMetric: IMetric | null = null
  isManageMode: boolean = false

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  async fetchMetricList(filter: IFilter<IMetric> = {}, includeDeleted?: boolean): Promise<void> {
    this.isFetching = true
    try {
      const [metricList, metricCount] = await Promise.all([
        getMetrics(filter, includeDeleted),
        countMetrics((filter.where as Where<IMetric>) ?? {})
      ])
      this.metrics = metricList
      this.metricsLength = metricCount
    } catch (error: any) {
      handleError(error as Error, 'stores/metricStore.ts', 'fetchMetricList', false)
    } finally {
      this.isFetching = false
    }
  }

  async createMetric(payload: ICreateMetricDto): Promise<IMetric> {
    const newMetric = await createMetric(payload)
    return newMetric
  }

  async updateMetric(id: number, payload: Partial<IMetric>): Promise<void> {
    await updateMetric(id, payload)
  }

  async deleteMetric(id: number): Promise<void> {
    await deleteMetric(id)
  }

  selectMetric(metric: IMetric | null): void {
    this.selectedMetric = metric
  }

  setManageMode(value: boolean): void {
    this.isManageMode = value
  }

  resetStore(): void {
    this.metrics = []
    this.metricsLength = 0
    this.selectedMetric = null
    this.isManageMode = false
  }
}
